export default function popScore(score, charIdx) {
    let counter = 0,
        opacity = 0;
    let popScoreInterval;

    let scoreColor = {
        "-1": [255, 0, 0],
        "+2": [0, 80, 0]
    };

    popScoreInterval = setInterval(() => {
        ctx.clearRect(textXPos + 60 * charIdx, 430, 60, 60);

        if (counter > 200) {
            opacity -= 4;

            clearInterval(popScoreInterval);
        } else if (counter > 100) {
            opacity -= 4;
        } else {
            opacity += 4;
        }

        ctx.font = "40px Roboto Mono";
        ctx.textAlign = "right";
        ctx.fillStyle =
            "rgba(" + scoreColor[score].join(",") + "," + opacity / 100.0 + ")";
        ctx.fillText(score, textXPos + 50 + 60 * charIdx, 480.5);
        ctx.textAlign = "start";
        ctx.fillStyle = "black";

        counter += 4;
    }, 1);
}



// WEBPACK FOOTER //
// ./js/components/score/pop_score.js